import book1 from "./stage8/book1.png";
import book2 from "./stage8/book2.png";
import book3 from "./stage8/book3.png";
import book4 from "./stage8/book4.png";
import book5 from "./stage8/book5.png";
import torchImg from "./stage8/torch.png";

/** Points written to DB `stage8` on successful restore. */
export const JOURNAL_POINTS = 100;

/** Puzzle 3 hotspot unlocked after Restoration Journal success. */
export const JOURNAL_UNLOCKS = "museum_archive";

/** Progressive UV reveal frames (blank → fully cleared). */
export const JOURNAL_PAGES = [book1, book2, book3, book4, book5];

export const JOURNAL_ASSETS = {
  torch: torchImg,
  pages: JOURNAL_PAGES,
};

export const JOURNAL_SUCCESS_COPY = {
  title: "Hidden notes discovered!",
  body: "The Museum Archive is ready to be restored.",
};

/** Scan score (0–1) thresholds to advance book1 → book5. */
export const JOURNAL_PAGE_THRESHOLDS = [0, 0.18, 0.38, 0.58, 0.82];
